export default "__VITE_ASSET__hDIddPO8__"